import { action } from 'mobx';
import React from 'react';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import Permissions from '@vromo/ui/components/Permissions';
import { observer } from 'mobx-react-lite';
import { useStore } from '@vromo/mobx-react/mobx-react';
import styled from '@emotion/styled';
import { RootStore } from '@vromo/dashboard/src/stores/RootStore';
import { useTranslation } from 'react-i18next';

const Tabs = styled.div`
    display: none;
    flex-direction: row;
    justify-content: space-around;
    padding: 8px;
    @media (max-width: 1000px) {
        display: flex;
    }
`;

const Tab = styled.div<{ active: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    color: ${({ active }) => (active ? '#1caef6' : 'inherit')};
`;

const Label = styled.span`
    font-size: 12px;
    margin-top: 4px;
`;

const MobileViewTabs = observer(() => {
    const { t } = useTranslation();
    const { viewStore } = useStore<RootStore>('rootStore');
    const isDriversTabActive = viewStore.tab === 'drivers';
    const isMapTabActive = viewStore.tab === 'map';
    const isJobsTabActive = viewStore.tab === 'jobs';
    const isChatTabActive = viewStore.tab === 'chat';

    return (
        <Tabs>
            <Tab active={isDriversTabActive} onClick={action(() => (viewStore.tab = 'drivers'))}>
                <FontAwesome icon="car" large />
                <Label>{t('dispatch.drivers')}</Label>
            </Tab>
            <Tab active={isMapTabActive} onClick={action(() => (viewStore.tab = 'map'))}>
                <i className="fas fa-map fa-lg" />
                <Label>{t('dispatch.map')}</Label>
            </Tab>
            <Tab active={isJobsTabActive} onClick={action(() => (viewStore.tab = 'jobs'))}>
                <FontAwesome icon="list" large />
                <Label>{t('dispatch.jobs')}</Label>
            </Tab>
            <Permissions minPosition="client">
                <Tab active={isChatTabActive} onClick={action(() => (viewStore.tab = 'chat'))}>
                    <FontAwesome icon="comment" large />
                    <Label>{t('dispatch.chat')}</Label>
                </Tab>
            </Permissions>
        </Tabs>
    );
});

export default MobileViewTabs;
